module.exports = __webpack_public_path__ + "img/1.6f3dd0db.jpg";